
import {
  Component,
  Vue,
  Inject,
  Prop,
  Watch,
  Ref
} from "vue-property-decorator";
import api from "@/api";
import Tinymce from "@/components/Tinymce/index.vue";
import Sticky from "@/components/Sticky/index.vue";
import { checkPermission } from "@/utils/permission";
import {
  OrganizationUnitDto,
  CreateOrEditActivityDto,
  ActivityStatus
} from "../../api/appService";
import { ElForm } from "element-ui/types/form";

@Component({
  components: { Tinymce, Sticky }
})
export default class CreateActivity extends Vue {
  @Ref() activityForm!: ElForm;
  id: number = 0;
  ous: OrganizationUnitDto[] = [];
  isSaving = false;
  form: CreateOrEditActivityDto = {
    title: undefined,
    suitableDesc: undefined,
    titleImagePath: undefined,
    activityStartTime: undefined,
    activityEndTime: undefined,
    applyEndTime: undefined,
    isLimitCount: undefined,
    maxCount: undefined,
    minCount: undefined,
    status: undefined,
    orginalPrice: undefined,
    price: undefined,
    placeDetail: {
      place: "",
      placeId: undefined,
      lat: undefined,
      lng: undefined
    },
    description: undefined,
    id: 0
  };

  async created() {
    if (this.$route.params && this.$route.params.id)
      this.id = parseInt(this.$route.params.id) || 0;
    await api.activity.getForEdit({ id: this.id }).then(res => {
      this.form = res.data!;
      this.ous = (res.schema as any).organizationUnitId;
    });
  }

  private checkPermission = checkPermission;

  private async onCancel() {
    setTimeout(() => {
      this.$router.push({ name: "activityList" });
    }, 300);
  }

  async onDraft() {
    this.form.status = ActivityStatus.Draft;
    console.log(this.form);
    this.save();
  }

  private async onSubmit() {
    this.form.status = ActivityStatus.Published;
    console.log(this.form);
    this.save();
  }

  async save() {
    this.activityForm.validate(valid => {
      console.log(valid);
      if (valid) {
        this.isSaving = true;
        console.log(this.form);
        let fn;
        if (this.form.id) {
          fn = api.activity.update({ body: this.form });
        } else {
          fn = api.activity.create({ body: this.form });
        }
        fn.then(
          res => {
            this.$message({
              type: "success",
              message: "成功"
            });
            setTimeout(() => {
              this.$router.push({ name: "activityList" });
            }, 300);
          },
          err => {
            this.isSaving = false;
          }
        );
      }
    });
  }

  private async handleSelect(e: any) {
    this.form.placeDetail!.placeId = e.uid;
    this.form.placeDetail!.lng = e.lng;
    this.form.placeDetail!.lat = e.lat;
    this.form.placeDetail!.place = e.district + " " + e.name;
  }

  private async querySearch(queryString: string, callback: Function) {
    api.client.getPlaceSuggestion({ query: queryString }).then(res => {
      const list: any[] = [];
      res.forEach(x => {
        list.push(
          Object.assign(
            {
              value: x.district + " " + x.name,
              address: x.name
            },
            x
          )
        );
      });
      console.log(list);
      callback(list);
    });
  }

  // 头像上传
  private async beforeAvatarUpload(file: any) {
    const isJPG = file.type === "image/jpeg";
    const isLt2M = file.size / 1024 / 1024 < 3;

    if (!isLt2M) {
      this.$message.error("上传头像图片大小不能超过 3MB!");
    }

    return isLt2M;
  }

  private async handleAvatarSuccess(res: any, file: any) {
    if (res.success) {
      this.form.titleImagePath = res.result;
    }
  }

  roleRule = {
    title: [
      {
        required: true,
        message: "活动名称不能为空",
        trigger: "blur"
      },
      {
        min: 3,
        max: 200,
        message: "长度在 3 到 200个字符",
        trigger: "blur"
      }
    ],
    titleImagePath: [
      {
        required: true,
        message: "必须上传图片",
        trigger: ["change", "blur"]
      }
    ],
    categoryId: [
      {
        required: true,
        message: "必须选择一个分类",
        trigger: ["change", "blur"]
      }
    ],
    courseCount: [
      {
        required: true,
        type: "number",
        message: "required",
        trigger: ["change", "blur"]
      }
    ],
    activityStartTime: [
      {
        required: true,
        message: "required",
        trigger: "blur"
      }
    ],
    activityEndTime: [
      {
        required: true,
        message: "required",
        trigger: "blur"
      }
    ],
    applyEndTime: [
      {
        required: true,
        message: "required",
        trigger: "blur"
      }
    ],
    description: [{ required: true, message: "简介必填", trigger: "blur" }],
    price: [{ type: "number", message: "必须为数字值" }],
    orginalPrice: [{ type: "number", message: "必须为数字值" }]
  };
}
